import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ROLES } from "./config/roles";

import AdminLayout from "./layouts/AdminLayout";
import StaffLayout from "./layouts/StaffLayout";
import CreditManagerLayout from "./layouts/CreditManagerLayout";
import AffiliatePartnerLayout from "./layouts/AffiliatePartnerLayout";
import BankingPartnerLayout from "./layouts/BankingPartnerLayout";
import SubadminLayout from "./layouts/SubadminLayout";

import ProtectedRoute from "./context/ProtectedRoute";
import RequireAuthRedirect from "./context/RequireAuthRedirect";

import Login from "./pages/Login";
import NotFound from "./pages/AdminPortal/NotFound";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <AuthProvider>
      <ToastContainer />

      <Routes>
        {/* ======================
            PUBLIC ROUTES
        ====================== */}

        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RequireAuthRedirect />} />

        {/* UNAUTHORIZED */}
        <Route path="/unauthorized" element={<NotFound />} />

        {/* ======================
            PROTECTED ROUTES
        ====================== */}

        <Route element={<ProtectedRoute allowedRoles={[ROLES.ADMIN]} />}>
          <Route path="/admin/*" element={<AdminLayout />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[ROLES.subAdmin]} />}>
          <Route path="/subAdmin/*" element={<SubadminLayout />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[ROLES.STAFF]} />}>
          <Route path="/staff/*" element={<StaffLayout />} />
        </Route>

        <Route
          element={<ProtectedRoute allowedRoles={[ROLES.CREDIT_MANAGER]} />}
        >
          <Route path="/credit-manager/*" element={<CreditManagerLayout />} />
        </Route>

        <Route
          element={<ProtectedRoute allowedRoles={[ROLES.BANKING_PARTNER]} />}
        >
          <Route path="/banking-partner/*" element={<BankingPartnerLayout />} />
        </Route>

        <Route
          element={<ProtectedRoute allowedRoles={[ROLES.AFFILIATE_PARTNER]} />}
        >
          <Route
            path="/affiliate-partner/*"
            element={<AffiliatePartnerLayout />}
          />
        </Route>

        {/* ======================
            FALLBACK
        ====================== */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
